import {createFileRoute} from '@tanstack/react-router'
import {secondLevelIndexRoute} from "../../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/')({
    ...secondLevelIndexRoute("/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
})
